import {
  addSlidesTabIndex
} from '@gravity-global/helpers/swiper/add-slides-tab-index';

const caseStudySlider = () => {
  const mainPattern = document.querySelectorAll('.gg-resource-banner');

  mainPattern.forEach((module) => {
    const swipers = module.querySelector('.posts-result');
    const swiperWrapper = module.querySelector('.gravity-block-dynamic-boxes--grid-view');
    const groupButton = module.querySelector('.gg-resource-banner__group-button');
    const groupSlider = module.querySelector('.gg-resource-banner__group-slider');
    const oneSlider = module.querySelector('.gg-resource-banner__group-slider-content__list-slider');

    if (oneSlider) {
      const paginationDiv = document.createElement('div');
      paginationDiv.classList.add('gg-resource-banner__pagination');
      oneSlider.insertAdjacentElement('afterend', paginationDiv);
    }

    if (!swipers || !swiperWrapper) {
      module.classList.add('not-slider');
      groupSlider.remove();
      return;
    }
    const swiperSlides = module.querySelectorAll('.gravity-block-dynamic-boxes__box');
    const swiperNext = module.querySelector('.gg-button-carousel__button-no-outline__next-btn > a');
    const swiperPrev = module.querySelector('.gg-button-carousel__button-no-outline__prev-btn > a');
    const pagination = module.querySelector('.gg-resource-banner__pagination');

    if (swiperPrev) swiperPrev.setAttribute('rel', 'prev');
    if (swiperNext) swiperNext.setAttribute('rel', 'next');

    swipers.classList.add('swiper-container');
    swiperWrapper.classList.add('swiper-wrapper');
    swiperSlides.forEach((slide) => {
      slide.classList.add('swiper-slide');
    });

    let carouselOptions = {
      centeredSlides: false,
      watchOverflow: true,
      watchSlidesProgress: true,
      slidesPerGroup: 1,
      slidesPerView: 1,
      spaceBetween: 40,
      allowTouchMove: true,
      navigation: {
        prevEl: swiperPrev,
        nextEl: swiperNext,
      },
      pagination: {
        el: pagination,
        clickable: true,
      },
      on: {
        init: (swiper) => addSlidesTabIndex(swiper),
        slideChange: (swiper) => addSlidesTabIndex(swiper),
      },
    };

    const numberOfSlides = swiperSlides.length;
    if (numberOfSlides <= 1) {
      groupButton.classList.add('d-none');
    } else {
      oneSlider.classList.add('flex-center-horizontal');
      carouselOptions.loop = true;
    }

    const carousel = new window.Swiper(swipers, carouselOptions);
    carousel.init();

    if (numberOfSlides > 1 && pagination) {
      pagination.swiper = carousel;
      pagination.swiper.update();
    }

  });
};

function adjustLinksHeight() {
  const bannerEvent = document.querySelector('.banner-event-webinars')
  const bannerPress = document.querySelector('.gg-banner-presses')
  const links = document.querySelectorAll('.gg-resource-banner article a');
  let maxHeight = 0;
  links.forEach(link => {
    //add button play and overlay gray
    const term = link.querySelector('.gravity-block-dynamic-boxes__terms')
    if(term) {
      const webinars = term.querySelector('li[data-term="webinars"]')
      if(webinars)
      {
        link.querySelector('.gravity-block-dynamic-boxes__group-wrapper:first-child').classList.add('button-play')
      }
    }
    const height = link.querySelector('.gravity-block-dynamic-boxes__group-wrapper:last-child').offsetHeight;
    if (maxHeight < height) {
      maxHeight = height;
    }
    link.style.alignItems = 'stretch';
  });

  links.forEach(link => { 
    const imageSlider = link.querySelector('.gravity-block-dynamic-boxes__group-wrapper:first-child');
    if (imageSlider && maxHeight > 250 && window.innerWidth > 640) {
        imageSlider.style.setProperty('height', maxHeight + 'px', 'important');
        if(bannerPress) {
          imageSlider.style.minHeight = maxHeight + 'px';
        }
    }
  });
}

caseStudySlider();

window.addEventListener('resize', adjustLinksHeight);
window.addEventListener('load', adjustLinksHeight);
